import axios from './axios'

class PickRepository {
  getFreePicks () {
    return axios
      .get(`/picks`)
      .then((response) => {
        return response.data
      })
      .catch((error) => console.log(error))
  }

  getPremium () {
    return axios.get(`/premium`).then((response) => {
      return response.data
    })
  }
}

export default new PickRepository()



// WEBPACK FOOTER //
// ./src/data/pick.repository.js